import AuthService from "s12-library/auth/helpers/AuthService";
import { config } from "./config";

export const authService = new AuthService(config);
